// test745
(745 && 0);
